import { toast } from "react-toastify";

import { clearNumber } from "../../functions";

const defaultUserProps = {name: '', cellphone: '', active: true}

export class SellerAppController {
  usersRefetchTimeout = null

  constructor(props) {
    this.newUserProps = defaultUserProps

    this.sellerAppModel = props.models.sellerApp


    _.bindAll(this, ['setNewUserProps', 'saveNewUser'])
  }

  validateNewUser (){
    const invalidFields = []

    if(!this.newUserProps.name.trim()) invalidFields.push("O campo Nome do usuário é obrigatório para adicionar um novo usuário")
    if(!this.newUserProps.cellphone) invalidFields.push("O campo Celular é obrigatório para adicionar um novo usuário")
    if(this.newUserProps.cellphone && clearNumber(this.newUserProps.cellphone).length < 11) invalidFields.push("O campo Celular deve conter um número válido para adicionar um novo usuário")

    invalidFields.forEach((error, i) => {
      setTimeout(() => {
        toast.error(error, { theme: "colored" });
      }, 200 * i);
    });

    return !invalidFields.length;
  };

  setNewUserProps(props) {
    this.newUserProps = {...this.newUserProps, ...props}
  }

  saveNewUser(e, cb) {
    if(e) e.preventDefault()

    if(!this.validateNewUser()) return

    this.sellerAppModel.createNewUser(this.newUserProps).then()
    this.newUserProps = defaultUserProps

    if(cb) cb()
  }

  getUsers() {
    if(this.usersRefetchTimeout) clearTimeout(this.usersRefetchTimeout)
    this.sellerAppModel.fetchUsers().then(()=>{
      this.usersRefetchTimeout = setTimeout(this.getUsers.bind(this), 500)
    })
  }

  refreshSecurityCode(userId) {
    this.sellerAppModel.refreshSecurityCode(userId).then()
  }

  setUserStatus(userId, status) {
    this.sellerAppModel.updateUser(userId, { active: status }).then()
  }

  removeUser(userId) {
    this.sellerAppModel.deleteUser(userId).then()
  }

}
